<template>
  <input
    :id="id"
    type="text"
    :class="`form-control ${additionalClass}`"
    :value="value"
    @input="debounceInput"
  />
</template>

<script>
import AutoNumeric from 'autonumeric';
import debounce from 'lodash.debounce';

export default {
  name: 'FormInputDecimal',
  props: {
    value: {
      type: [Number, String],
      default: '',
    },
    id: {
      type: String,
      default: '',
    },
    decimalPlaces: {
      type: [Number, String],
      default: 2,
    },
  },
  computed: {
    additionalClass() {
      return `form-control-integer-${this.$outputHelper.generateUniqueId()}`;
    },
  },
  mounted() {
    const defaultOptions = {
      decimalPlaces: this.decimalPlaces,
      minimumValue: 0,
      digitGroupSeparator: '',
      decimalCharacter: ',',
      allowDecimalPadding: 'floats',
      watchExternalChanges: true,
      overrideMinMaxLimits: 'ignore',
    };

    new AutoNumeric(`.${this.additionalClass}`, defaultOptions);
  },
  methods: {
    // eslint-disable-next-line func-names
    debounceInput: debounce(function (e) {
      this.$emit('input', e.target.value);
    }, 500),
  },
};
</script>
